import React from 'react';

/**
 * Compact form field: label + control on the same row.
 *
 * Uses CSS Grid (fixed label column + flex input) so the layout stays
 * one line per field regardless of label length. Drop-in replacement
 * for a stacked <CommonInput> / <MaskedField> / <CommonSelect>.
 */
const InlineFormRow = ({
  label,
  required = false,
  children,
  error,
  hint,
  labelWidth = 120,
  style,
}) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `${labelWidth}px 1fr`,
        alignItems: 'center',
        gap: '0 10px',
        marginBottom: '0.5rem',
        ...(style || {}),
      }}
    >
      <label
        style={{
          fontSize: '0.8125rem',
          fontWeight: 500,
          justifySelf: 'end',
        }}
      >
        {label}
        {required && (
          <span className="text-danger" style={{ marginLeft: 3 }}>
            *
          </span>
        )}
      </label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
        {children}
        {hint && (
          <small className="text-muted" style={{ fontSize: '0.6875rem', lineHeight: 1.3 }}>
            {hint}
          </small>
        )}
      </div>
      {error && (
        <div style={{ gridColumn: '1 / -1', marginLeft: labelWidth }}>
          <div className="text-danger" style={{ fontSize: '0.6875rem' }}>
            {Array.isArray(error) ? error[0] : error}
          </div>
        </div>
      )}
    </div>
  );
};

export default InlineFormRow;
